
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M8.504 6.021V8.72M7.328 2.666 1.526 12.45a1.395 1.395 0 0 0 .491 1.885c.207.123.441.189.68.191h11.606a1.36 1.36 0 0 0 1.175-.698 1.4 1.4 0 0 0-.004-1.378L9.672 2.666A1.38 1.38 0 0 0 8.5 2a1.36 1.36 0 0 0-1.172.666M9 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"}})])
          )
        }
      }
    